import _ from 'lodash';
import {errors, generateError} from './validations/errors';
import monitoring from './monitoring';
import BIReporter from './bi/BIReporter';
class PlatformUtils {
    constructor() {
        this.staticEventHandlers = {};
        this.queryParametersMap = {};
    }

    setExperiments(experiments) { this.experiments = experiments; } //eslint-disable-line no-return-assign

    isExperimentOpen(name) { return _.includes(this.experiments, name); }

    initGlobals(platformUtils) {
        this.RGI = platformUtils.RGI;
    }

    init(platformUtils, onUpdateCallback) {
        platformUtils.RMI.setUpdateCallback(onUpdateCallback);
        this.RMI = platformUtils.RMI;
        this.componentsHooks = platformUtils.componentsHooks;
    }

    initUtilities(platformUtils) {
        this.linkUtils = platformUtils.linkUtils;
        this.backgroundUtils = platformUtils.backgroundUtils;
        this.videoUrlsUtils = platformUtils.videoUrlsUtils;
        this.repeaterUtils = platformUtils.repeaterUtils;
        this.typeUtils = platformUtils.typeUtils;
        this.uriUtils = platformUtils.uriUtils;
        this.widgetUtils = platformUtils.widgetUtils;
        this.richTextUtils = platformUtils.richTextUtils;
        this.mediaSrcHandler = platformUtils.mediaSrcHandler;
        this.pubSubService = platformUtils.pubSubService;
        this.messageService = platformUtils.messageService;
    }

    addQueryParameters(params) {
        _.assign(this.queryParametersMap, params);
    }

    setQueryParameters(params) {
        this.queryParametersMap = params;
    }

    getQueryParameter(parameterName) { return this.queryParametersMap[parameterName] || null; }

    initMonitoringServices(monitoringServices) { this.monitoringServices = monitoringServices; } //eslint-disable-line no-return-assign

    getMonitoringServices() { return this.monitoringServices; }

    setStaticEventHandlers(eventHandlers, contextId) {
        this.staticEventHandlers = _.mapValues(eventHandlers, (callback) => ({
            contextId,
            controllerId: contextId,
            callback
        }));
    }

    throwIfMissing(param, apiName) {
        if (!param) {
            const errorMessage = apiName ? generateError.error_api_with_name_before_page_ready({apiName}) : errors.ERROR_API_BEFORE_PAGE_READY;
            throw new monitoring.MonitoringErrorToIgnore(errorMessage);
        }
        return param;
    }

    getStaticEventHandler(name, onlyCallback) {
        const staticEventHandler = this.staticEventHandlers[name]; // TODO - backward compatibility - remove after worker next release
        if (!staticEventHandler) {
            return null;
        } else if (onlyCallback) {
            return staticEventHandler.callback;
        }

        return staticEventHandler;
    }

    getRMI(apiName) { return this.throwIfMissing(this.RMI, apiName); }

    getRGI() { return this.RGI; }

    getWixSelector(apiName) { return this.throwIfMissing(this.wixSelector, apiName); }

    setWixSelector(wixSelector) {
        this.wixSelector = wixSelector;
    }

    getEmitter(apiName) { return this.throwIfMissing(this.emitter, apiName); }

    setEmitter(emitter) {
        this.emitter = emitter;
    }

    getLinkUtils() { return this.linkUtils; }

    getBackgroundUtils() { return this.backgroundUtils; }

    getVideoUrlUtils() { return this.videoUrlsUtils; }

    getRepeaterUtils() { return this.repeaterUtils; }

    getTypeUtils() { return this.typeUtils; }

    getComponentsHooks() { return this.componentsHooks; }

    getUriUtils() { return this.uriUtils; }

    getWidgetUtils() { return this.widgetUtils; }

    getRichTextUtils() { return this.richTextUtils; }

    getMediaSrcHandler() { return this.mediaSrcHandler; }

    getPubSubService() { return this.pubSubService; }

    setBiReporter(biServices) {
        const pageUrl = this.RGI.getNavigationInfo().currentPageFullUrl;
        this.biReporter = new BIReporter(biServices, pageUrl);
    }

    getBIReporter() { return this.biReporter; }

    getMessageService() { return this.messageService; }

    getEnv() { return this.getQueryParameter("renderingEnv") || "browser"; }

    wSpyLog(...params) {
        if (self.wSpy) {
          self.wSpy.log(...params);
        }
    }
}

const platformUtils = new PlatformUtils();

export default platformUtils;
